module.exports = __webpack_public_path__ + "static/media/CAC.8858db5f.png";